var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},_vm._l((_vm.imgurls),function(item){return _c('div',{key:item.id,staticStyle:{"width":"980px","margin":"-10px auto"}},[_c('el-image',{attrs:{"src":item.url,"z-index":1}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }